var map = {
	"./Apalla": 627,
	"./Apalla.tsx": 627,
	"./AvenueA": 6721,
	"./AvenueA.tsx": 6721,
	"./CSJ": 6338,
	"./CSJ.tsx": 6338,
	"./Campbells": 4273,
	"./Campbells.tsx": 4273,
	"./CanadianMilk": 9306,
	"./CanadianMilk.tsx": 9306,
	"./Evree": 3527,
	"./Evree.tsx": 3527,
	"./FWC": 9401,
	"./FWC.tsx": 9401,
	"./OANDA": 5198,
	"./OANDA.tsx": 5198,
	"./Rakuten": 9323,
	"./Rakuten.tsx": 9323,
	"./RikkiTikki": 1770,
	"./RikkiTikki.tsx": 1770,
	"./TDAeroplan": 9033,
	"./TDAeroplan.tsx": 9033,
	"./TDHousie": 9029,
	"./TDHousie.tsx": 9029,
	"./UGO": 4573,
	"./UGO.tsx": 4573
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4503;